import { Shelf, Stack } from "capitalrx-components-2.0/lib/layout";


export const STANDARD_RESPONSIVE_LAYOUT = {
  Layout: {
    desktop: Shelf,
    mobile: Stack,
  },
};

export const PROVIDER_MANAGEMENT_LAYOUT = {
  twelve: {
    desktop: 12,
    mobile: 12,
  },
  six: {
    desktop: 6,
    mobile: 12,
  },
  sixFull: {
    desktop: 6,
    tablet: 12,
    mobile: 12,
  },
  four: {
    desktop: 4,
    mobile: 12,
  },
  fourFull: {
    desktop: 4,
    tablet: 12,
    mobile: 12,
  },
  three: {
    desktop: 3,
    mobile: 6,
  },
  threeFull: {
    desktop: 3,
    tablet: 6,
    mobile: 12,
  },
  two: {
    desktop: 2,
    mobile: 12,
  },
  isCompressed: {
    desktop: false,
    tablet: false,
    mobile: true,
  },
};
